import { z } from 'zod';
import { InvalidRefreshTokenError } from 'libs/end-to-end/src/types/errors/invalid-refresh-token-error';
import { ResponseToJsonError } from 'libs/end-to-end/src/types/errors/response-to-json-error';
import { UnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';

export const RefreshTokenError = z.union([
  InvalidRefreshTokenError,
  ResponseToJsonError,
  UnknownError,
]);

export type RefreshTokenError = z.infer<typeof RefreshTokenError>;
